import { render } from "./agregarinvitados.vue?vue&type=template&id=6c782ccc&scoped=true"
import script from "./agregarinvitados.vue?vue&type=script&lang=js"
export * from "./agregarinvitados.vue?vue&type=script&lang=js"

import "./agregarinvitados.vue?vue&type=style&index=0&id=6c782ccc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c782ccc"]])

export default __exports__